/* axios公共入口 */
let queryString = require('querystring');
//
import GLOBAL from '../../assets/js/Global.js'

//
/*import { Indicator } from 'mint-ui';*/
const EntryAxions = {};
//
EntryAxions.apiRequest = function([_Axios,{url,encrypt='',data}],callback)
{
    // 转义
    //data['user_id'] = GlobalConfig['user_id'];
    //
    let data_else = '';
    //
    if(  data != undefined && data.length != 0  ) {
        //=encodeURI( JSON.stringify(data) );
    }
    // 转码
    if(encrypt != ''){
        //data_else = encrypt( data_else );
    }
 /*   if(sessionStorage.getItem('user_token') && sessionStorage.getItem('user_token') !=''){
        //
       /!* data.token = sessionStorage.getItem('user_token');*!/
    }*/
    // 打印POST数据
  /*  console.log('post数据:'+JSON.stringify(data));*/
    // 异步获取数据
    _Axios.post(url,queryString.stringify(data))
        .then(function (response) {
            if( callback != undefined && callback !='' ){
                //response.type = 0;
                /*模拟数据*/
                /*if ((data.page_number != '' &&  data.page_number !=undefined ) && (data.page != undefined && data.page >= 0  ) ){
                    var arr=response.data;
                    // 不为空的情况下等于默认值
                    //arr = JSON.stringify( eval("(" + arr + ")").slice(data.data_page*data.data_number,data.data_page*data.data_number+(+data.data_number) ) );
                    return callback.apply(this,[arr]);
                }else{*/
               /* console.log('初始接口'+JSON.stringify(response.data))*/
                // 如果res= 9 的情况下清除token
            /*    if(response.data['status_code']==402){
                    /!*console.log('res:'+response.data['res']);
                    sessionStorage.removeItem('user_token');*!/
                  GLOBAL.delete("token_arr");
                    // 隐藏
                    // 跳转
                    window.location.href='/app/';
                    //window.location.reload();
                    return false;
                }*/
                return callback.apply(this,[response]);
                //}
            }
        })
        .catch(function (error) {
            // 关闭loading
          /*  Indicator.close();*/
            //输出错误
          if(error.response.data['status_code']==402 || error.response.data['status_code']==401){
            GLOBAL.delete("token");
            GLOBAL.delete("user");
            Indicator.close();
            window.location.href='#/Login'


            // 隐藏
            // 跳转
            //window.location.reload();
            return false;
          }
          return callback.apply(this,[error.response]);
        /*  if (error.response) {
            // 请求已发出，但服务器响应的状态码不在 2xx 范围内
            console.log(error.response.data);

          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);

          }*/
        });
}
EntryAxions.apiUser = function([_Axios,{url,encrypt='',data}],callback)
{
  // 转义
  //data['user_id'] = GlobalConfig['user_id'];
  //
  let data_else = '';
  //
  if(  data != undefined && data.length != 0  ) {
    //=encodeURI( JSON.stringify(data) );
  }
  // 转码
  if(encrypt != ''){
    //data_else = encrypt( data_else );
  }
  /*if(sessionStorage.getItem('token_arr') && sessionStorage.getItem('token_arr') !=''){
    //
    let token_arr=GLOBAL.fetch("token_arr");
    data.token=token_arr['access_token'];
   /!* data.token = sessionStorage.getItem('user_token');*!/
  }*/
  // 打印POST数据
 /* console.log('post数据:'+JSON.stringify(data));*/
  // 异步获取数据
  _Axios.get(url,queryString.stringify(data))
    .then(function (response) {
      if( callback != undefined && callback !='' ){
        //response.type = 0;
        /*模拟数据*/
        /*if ((data.page_number != '' &&  data.page_number !=undefined ) && (data.page != undefined && data.page >= 0  ) ){
            var arr=response.data;
            // 不为空的情况下等于默认值
            //arr = JSON.stringify( eval("(" + arr + ")").slice(data.data_page*data.data_number,data.data_page*data.data_number+(+data.data_number) ) );
            return callback.apply(this,[arr]);
        }else{*/
        /* console.log('初始接口'+JSON.stringify(response.data))*/
        // 如果res= 9 的情况下清除token
      /*  if(response.data['status_code']==402){
        /!*  console.log('res:'+response.data['res']);*!/
      /!*    sessionStorage.removeItem('user_token');*!/
          GLOBAL.delete("token_arr");
          // 隐藏
          // 跳转
          window.location.href='/app/';
          //window.location.reload();
          return false;
        }*/
        return callback.apply(this,[response]);
        //}
      }
    })
    .catch(function (error) {
      // 关闭loading
      /*  Indicator.close();*/
      //输出错误
      if(error.response.data['status_code']==402 || error.response.data['status_code']==401){
        GLOBAL.delete("token");
        GLOBAL.delete("user");
        Indicator.close();
        window.location.href='#/Login'
        //'
        //window.location.reload();
        return false;
      }
      return callback.apply(this,[error.response]);
      /*  if (error.response) {
          // 请求已发出，但服务器响应的状态码不在 2xx 范围内
          console.log(error.response.data);

        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);

        }*/
    });
}


EntryAxions.apiPut = function([_Axios,{url,encrypt='',data}],callback)
{
  // 转义
  //data['user_id'] = GlobalConfig['user_id'];
  //
  let data_else = '';
  //
  if(  data != undefined && data.length != 0  ) {
    //=encodeURI( JSON.stringify(data) );
  }
  // 转码
  if(encrypt != ''){
    //data_else = encrypt( data_else );
  }
/*  if(sessionStorage.getItem('token_arr') && sessionStorage.getItem('token_arr') !=''){

  }*/
  // 打印POST数据
  /* console.log('post数据:'+JSON.stringify(data));*/
  // 异步获取数据
  _Axios.put(url,queryString.stringify(data))
    .then(function (response) {
      if( callback != undefined && callback !='' ){
        //response.type = 0;
        /*模拟数据*/
        /*if ((data.page_number != '' &&  data.page_number !=undefined ) && (data.page != undefined && data.page >= 0  ) ){
            var arr=response.data;
            // 不为空的情况下等于默认值
            //arr = JSON.stringify( eval("(" + arr + ")").slice(data.data_page*data.data_number,data.data_page*data.data_number+(+data.data_number) ) );
            return callback.apply(this,[arr]);
        }else{*/
        /* console.log('初始接口'+JSON.stringify(response.data))*/
        // 如果res= 9 的情况下清除token
        /*  if(response.data['status_code']==402){
          /!*  console.log('res:'+response.data['res']);*!/
        /!*    sessionStorage.removeItem('user_token');*!/
            GLOBAL.delete("token_arr");
            // 隐藏
            // 跳转
            window.location.href='/app/';
            //window.location.reload();
            return false;
          }*/
        return callback.apply(this,[response]);
        //}
      }
    })
    .catch(function (error) {
      // 关闭loading
      /*  Indicator.close();*/
      //输出错误
      if(error.response.data['status_code']==402 || error.response.data['status_code']==401){
        GLOBAL.delete("token");
        GLOBAL.delete("user");
        Indicator.close();
        window.location.href='#/Login'
        //window.location.reload();
        return false;
      }
      return callback.apply(this,[error.response]);
      /*  if (error.response) {
          // 请求已发出，但服务器响应的状态码不在 2xx 范围内
          console.log(error.response.data);

        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);

        }*/
    });
}


EntryAxions.apiDelete = function([_Axios,{url,encrypt='',data}],callback)
{
  // 转义
  //data['user_id'] = GlobalConfig['user_id'];
  //
  let data_else = '';
  //
  if(  data != undefined && data.length != 0  ) {
    //=encodeURI( JSON.stringify(data) );
  }
  // 转码
  if(encrypt != ''){
    //data_else = encrypt( data_else );
  }
/*  if(sessionStorage.getItem('token_arr') && sessionStorage.getItem('token_arr') !=''){

  }*/
  // 打印POST数据
  /* console.log('post数据:'+JSON.stringify(data));*/
  // 异步获取数据
  _Axios.delete(url,queryString.stringify(data))
    .then(function (response) {
      if( callback != undefined && callback !='' ){
        return callback.apply(this,[response]);
        //}
      }
    })
    .catch(function (error) {
      // 关闭loading
      /*  Indicator.close();*/
      //输出错误
      if(error.response.data['status_code']==402 || error.response.data['status_code']==401){
        GLOBAL.delete("token");
        GLOBAL.delete("user");
        Indicator.close();
        window.location.href='#/Login'

        //window.location.reload();
        return false;
      }
      return callback.apply(this,[error.response]);
      /*  if (error.response) {
          // 请求已发出，但服务器响应的状态码不在 2xx 范围内
          console.log(error.response.data);

        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);

        }*/
    });
}
EntryAxions.apiFile = function([_Axios,{url,encrypt='',data}],callback)
{
  // 转义
  //data['user_id'] = GlobalConfig['user_id'];
  //
  let data_else = '';
  //
  if(  data != undefined && data.length != 0  ) {
    //=encodeURI( JSON.stringify(data) );
  }
  // 转码
  if(encrypt != ''){
    //data_else = encrypt( data_else );
  }
/*  if(sessionStorage.getItem('user_token') && sessionStorage.getItem('user_token') !=''){
    //
    /!* data.token = sessionStorage.getItem('user_token');*!/
  }*/
  // 打印POST数据
  /*  console.log('post数据:'+JSON.stringify(data));*/
  // 异步获取数据
  _Axios.post(url,data)
    .then(function (response) {
      if( callback != undefined && callback !='' ){
        return callback.apply(this,[response]);
        //}
      }
    })
    .catch(function (error) {
      // 关闭loading
      /*  Indicator.close();*/
      //输出错误
      if(error.response.data['status_code']==402 || error.response.data['status_code']==401){
        GLOBAL.delete("token");
        GLOBAL.delete("user");
        Indicator.close();
        window.location.href='#/Login'

        // 隐藏
        // 跳转
        //window.location.reload();
        return false;
      }
      return callback.apply(this,[error.response]);
      /*  if (error.response) {
          // 请求已发出，但服务器响应的状态码不在 2xx 范围内
          console.log(error.response.data);

        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);

        }*/
    });
}
EntryAxions.apiFiles = function([_Axios,{url,encrypt='',data}],callback)
{
  // 转义
  //data['user_id'] = GlobalConfig['user_id'];
  //
  let data_else = '';
  //
  if(  data != undefined && data.length != 0  ) {
    //=encodeURI( JSON.stringify(data) );
  }
  // 转码
  if(encrypt != ''){
    //data_else = encrypt( data_else );
  }
/*  if(sessionStorage.getItem('user_token') && sessionStorage.getItem('user_token') !=''){
    //
    /!* data.token = sessionStorage.getItem('user_token');*!/
  }*/
  // 打印POST数据
  /*  console.log('post数据:'+JSON.stringify(data));*/
  // 异步获取数据
  _Axios.put(url,data)
    .then(function (response) {
      if( callback != undefined && callback !='' ){
        return callback.apply(this,[response]);
        //}
      }
    })
    .catch(function (error) {
      // 关闭loading
      /*  Indicator.close();*/
      //输出错误

      if(error.response.data['status_code']==402 || error.response.data['status_code']==401){
        GLOBAL.delete("token");
        GLOBAL.delete("user");
        Indicator.close();
        window.location.href='#/Login'


        // 隐藏
        // 跳转
        //window.location.reload();
        return false;
      }
      return callback.apply(this,[error.response]);
      /*  if (error.response) {
          // 请求已发出，但服务器响应的状态码不在 2xx 范围内
          console.log(error.response.data);

        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);

        }*/
    });

};

//
export default EntryAxions;



// WEBPACK FOOTER //
// ./src/assets/js/entry.axions.api.js